const state = {
    addEditUser: false,
    addEditUserData: null,
    addEditTeam: false,
    addEditTeamData: null,
}

const getters = {
    isOpened: (state) => (modal) => !!state[modal],
    getProperty: (state) => (property) => state[property],
}

const mutations = {
    OPEN: (state, modal) => (state[modal] = true),
    CLOSE: (state, modal) => (state[modal] = false),
    SET_DATA: (state, payload) => (state[payload.key] = payload.data),
}

const actions = {
    open: ({ commit }, modal) => commit('OPEN', modal),
    close: ({ commit }, modal) => commit('CLOSE', modal),
    setData: ({ commit }, payload) => commit('SET_DATA', payload),
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
